import { redirect } from "react-router-dom";

export const redirectToLogin = () => {
  return redirect("/login");
};
